import { AspectRatio, Box, Flex, Text } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { type CdpVendor } from "lib/sanity/queries/compare-cdps";
import React from "react";
import { Link } from "ui/link";
import { cardHoverTranslation } from "utils";

type CdpVsCardProps = {
  slug: string;
  firstCdpVendor: CdpVendor;
  secondCdpVendor: CdpVendor;
};

export function CdpVsCard({ slug, firstCdpVendor, secondCdpVendor }: CdpVsCardProps) {
  return (
    /**
     * Parent element is necessary to avoid a layout shift when hovering over the bottom of the card.
     * See `cardHoverTranslation` for more details.
     */
    <Box as="li" className="group" pos="relative">
      <Link
        variant="unstyled"
        href={`/compare-cdps/${slug}`}
        boxSize="100%"
        borderRadius="base"
        _groupHover={cardHoverTranslation}
      >
        <Flex
          flexDirection="column"
          alignItems="start"
          w="100%"
          py={{ base: "small", lg: "big" }}
          pl={{ base: "small", xl: "big" }}
          pr="small"
          bg="brand.background.light"
          borderRadius="base"
          boxShadow="card"
          border="1px"
          borderColor="new.gray.150"
        >
          <Flex
            gap={{ base: 6, lg: "big" }}
            mb={{ base: 6, lg: 8 }}
            alignItems="center"
            fontSize="brand.lg"
            fontWeight="bold"
          >
            <AspectRatio ratio={1 / 1} w="36px">
              <FillImage
                src={`${firstCdpVendor.logoUrl}?w=72`}
                alt={`${firstCdpVendor.name} logo.`}
                style={{
                  objectFit: "contain",
                }}
                placeholder="empty"
              />
            </AspectRatio>

            <Text>vs</Text>

            <AspectRatio ratio={1 / 1} w="36px">
              <FillImage
                src={`${secondCdpVendor.logoUrl}?w=72`}
                alt={`${secondCdpVendor.name} logo.`}
                style={{
                  objectFit: "contain",
                }}
                placeholder="empty"
              />
            </AspectRatio>
          </Flex>

          <Flex width="100%" justifyContent="space-between" alignItems="center">
            <Text fontWeight="semibold" fontSize="brand.md" maxW={{ lg: "150px" }}>
              {firstCdpVendor.name} vs {secondCdpVendor.name}
            </Text>
          </Flex>
        </Flex>
      </Link>
    </Box>
  );
}
